(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["product_images_slider"] && !window.DesignMode) return;
  try {
    

  const product_images_slider = new Swiper(".product_images_slider", {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        800: {
          slidesPerView: 2,
        },
        1300: {
          slidesPerView: 3,
        },
      },
  });

  } catch(e) { console.error(e); }
})();
      })();
